export default __webpack_public_path__ + "static/media/SA_Templates_M2.8636e993.pdf";